
import { defineComponent } from 'vue'
import { iFunction } from '../../FunctionsCatalog'
import { VCodeMirror } from 'vue3-code-mirror'
import Dropdown from 'primevue/dropdown'
import functionsCatalogScriptTabDescriptor from './FunctionsCatalogScriptTabDescriptor.json'

export default defineComponent({
    name: 'function-catalog-script-tab',
    components: { Dropdown, VCodeMirror },
    props: { propFunction: { type: Object }, readonly: { type: Boolean } },
    data() {
        return {
            functionsCatalogScriptTabDescriptor,
            selectedFunction: {} as iFunction,
            code: '',
            trainModelCode: '',
            useModelCode: '',
            codeMirror: {} as any,
            options: {
                mode: '',
                lineWrapping: true,
                theme: 'eclipse',
                lineNumbers: true,
                autoRefresh: true
            }
        }
    },
    created() {
        this.loadFunction()
        this.setupCodeMirror()
    },
    methods: {
        loadFunction() {
            this.selectedFunction = this.propFunction as iFunction

            if (this.selectedFunction) {
                this.code = this.selectedFunction.onlineScript ?? ''
                this.trainModelCode = this.selectedFunction.trainModelCode ?? ''
                this.useModelCode = this.selectedFunction.useModelCode ?? ''
                this.options.mode = this.selectedFunction.language.toLowerCase()
            }
        },
        setupCodeMirror() {
            const interval = setInterval(() => {
                if (!this.$refs.codeMirror) return
                this.codeMirror = (this.$refs.codeMirror as any).editor as any
                this.codeMirror.setOption('readOnly', this.readonly)
                setTimeout(() => {
                    this.codeMirror.refresh()
                }, 0)
                clearInterval(interval)
            }, 200)
        },
        onKeyUp() {
            this.selectedFunction.onlineScript = this.code
        },
        onKeyUpTrainModel() {
            this.selectedFunction.trainModelCode = this.trainModelCode
        },
        onKeyUpUseModel() {
            this.selectedFunction.useModelCode = this.useModelCode
        }
    }
})
